import Drift from 'drift-zoom';

/**
 * Handle PDP zoom for Product slider's images
 *
 * @param {}
 * @return {void}
 */

const $zoomTrigger = $('.js-zoom-image img');
const $paneContainer = $('.js-zoom-pane')[0];

const initZoom = () => {
  $zoomTrigger.each(function() {
    const $this = $(this);
    const $element = $this[0];

    let drift = new Drift($element, {
      paneContainer: $paneContainer,
      inlinePane: false,
      zoomFactor: 3,
      showWhitespaceAtEdges: false,
      hoverBoundingBox: true
    });

    $(window).on('resize', function() {
      if ($(window).outerWidth() < 1024) {
        drift.disable();
      } else {
        drift.enable();
      }
    });
  });
}

$(window).on('load', function() {
  if ($(window).outerWidth() > 1023) {
    initZoom();
  }
});

